import React from 'react'

import CopyButton from 'components/reusable/CopyButton'
import { capitalize } from 'utils'
import {
  type MembersCoveredParticipant,
  MembersCoveredParticipantQualifyingLifeEventStatus,
  type MembersCoveredParticipantQualifyingLifeEventStatus as MembersCoveredParticipantQualifyingLifeEventStatusType,
  MembersEnrollmentOverviewProgressState,
  type MembersEnrollmentOverviewProgressState as MembersEnrollmentOverviewProgressStateType,
} from 'utils/web_api.schemas'

import EnrollmentProgress from '../EnrollmentProgress/EnrollmentProgress'

interface CoveredDependentProps {
  coveredParticipant: MembersCoveredParticipant;
  participantEnrollmentProgressState?: MembersCoveredParticipantQualifyingLifeEventStatusType;
  children?: React.ReactNode;
}

const getEnrollmentState = (participantEnrollmentProgressState: MembersCoveredParticipantQualifyingLifeEventStatusType): MembersEnrollmentOverviewProgressStateType => {
  switch (participantEnrollmentProgressState) {
    case MembersCoveredParticipantQualifyingLifeEventStatus.complete:
      return MembersEnrollmentOverviewProgressState.enrolled
    case MembersCoveredParticipantQualifyingLifeEventStatus.in_progress:
      return MembersEnrollmentOverviewProgressState.on_track
    case MembersCoveredParticipantQualifyingLifeEventStatus.awaiting_confirmation:
      return MembersEnrollmentOverviewProgressState.needs_attention
  }
}

const CoveredDependent: React.FC<CoveredDependentProps> = ({
  coveredParticipant,
  participantEnrollmentProgressState,
  children,
}) => {
  return (
    <div
      className='border border-gray-100 rounded-lg p-3 shadow-sm'
    >
      <div className='flex justify-between items-center gap-2'>
        <div className='flex flex-col'>
          <div className='body'>
            {coveredParticipant.given_name} {coveredParticipant.family_name}
          </div>
          <span className='body-sm text-gray-500'>
            {capitalize(coveredParticipant.relationship)}
          </span>
        </div>
        {
          coveredParticipant.carrier_member_id
            ? (
              <div className='body text-gray-500 flex items-center self-baseline -mt-1'>
                <div className='font-mono'>{coveredParticipant.carrier_member_id}</div>
                <CopyButton valueToCopy={coveredParticipant.carrier_member_id} variant='default' />
              </div>
              )
            : participantEnrollmentProgressState
              ? (
                <div className='self-baseline'>
                  <EnrollmentProgress
                    state={getEnrollmentState(participantEnrollmentProgressState)}
                    showCaption={false}
                  />
                </div>
                )
              : null
        }
      </div>

      {children}
    </div>
  )
}

export default CoveredDependent
